export default __webpack_public_path__ + "static/media/680.ff7c4d68.jpg";